import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import moment from 'moment'
import cookie from 'react-cookies'
import { trackPromise } from 'react-promise-tracker'

import {
  getSpecificMeal,
  addMealToDailyBalance,
  getUserDailyBalance,
  addMealToCart,
} from '../../../Api/dietApi/userInfo'

import MealDetailsScreen from './MealDetailsScreen.tsx'

class MealDetailsScreenContainer extends Component {
  state = {
    ingredientInCart: [],
    // isDemoAccount: cookie.load('userDemoMode'),
    challengeMode: this.props.location.challengeMode
  }

  componentDidMount = async () => {
    this.getMeal(this.props.match.params.mealId)
    this.getDates()
    this.getUserDiet()
  }

  getDates = () => {
    this.setState({
      todayDate: moment().format('YYYY-MM-DD'),
      chosenDate: this.props.match.params.chosenDate
        ? this.props.match.params.chosenDate
        : null,
    })
  }

  getUserDiet = async () => {
    const userBalance = await trackPromise(
      getUserDailyBalance(moment().format('YYYY-MM-DD'))
    )

    if (userBalance) {
      this.setState({
        diet: userBalance.diet,
      })
    }
  }

  redirectToMainScreen = () => {
    this.props.history.push({
      pathname: `/dieta`,
      state: {
        returnedDate: this.state.chosenDate
          ? this.state.chosenDate
          : this.state.currentDate,
          challengeMode: this.state.challengeMode
      },
    })
  }

  getMeal = async (mealId) => {
    const meal = await trackPromise(getSpecificMeal(mealId))

    this.setState({
      meal: meal,
    })
  }

  addMeal = (mealId) => {
    const currentDate = moment().format('YYYY-MM-DD')

    if (
      this.state.chosenDate != currentDate &&
      (this.state.chosenDate != null || this.state.chosenDate != undefined)
    ) {
      addMealToDailyBalance(
        mealId,
        this.props.location.state.chosedMealType,
        this.state.chosenDate
      )
      cookie.remove('userBackFromDietDate')
      setTimeout(() => {
        this.redirectToMainScreen()
      }, 500)
    } else {
      addMealToDailyBalance(
        mealId,
        this.props.location.state.chosedMealType,
        currentDate
      )
      cookie.remove('userBackFromDietDate')
      setTimeout(() => {
        this.redirectToMainScreen()
      }, 500)
    }
  }

  addIngredientToCart = async (mealId) => {
    await addMealToCart(
      mealId,
      this.state.chosenDate
        ? this.state.chosenDate
        : moment().format('YYYY-MM-DD')
    )
    await this.setState({
      ingredientInCart: [...this.state.ingredientInCart, mealId],
    })
  }

  changeDiet = () => {
    this.props.history.push({
      pathname: '/dieta/wybierz-diete/',
      userChangeDiet: true,
      challengeMode: this.state.challengeMode
    })
  }

  render() {
    return (
      <MealDetailsScreen
        meal={this.state.meal}
        addMeal={this.addMeal}
        diet={this.state.diet}
        chosenDate={this.state.chosenDate}
        addIngredientToCart={this.addIngredientToCart}
        ingredientInCart={this.state.ingredientInCart}
        changeDiet={this.changeDiet}
        // isDemoAccount={this.state.isDemoAccount}
        challengeMode= {this.state.challengeMode}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(MealDetailsScreenContainer)
